import { useCallback, useEffect, useMemo, useState } from "react";
import "./SubscriptionPriceSectionComponent.scss";
import SubscriptionPriceCardComponent from "../SubscriptionPriceCard/SubscriptionPriceCardComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  getDowngradeReqDetailsClear,
  getSubscriptionPlan,
  getSubscriptionPlanClear,
} from "../../../../redux/subscription/actions";
import CONFIG from "../../../../utils/config";
import API_LIST from "../../../../utils/apiList";
import Slider from "react-slick";
import _ from "lodash";
import PrevArrow from "../../../LearningPaths/PrevArrow";
import NextArrow from "../../../LearningPaths/NextArrow";
import useLogin from "../../../../custom-hooks/useLogin";
import { SessionKeys, subscriptionTrailType } from "../../../../utils/AppUtils";
import ConfirmModal from "../../../modal/ConfirmModal";
import {
  changeSubscriptionPlanClear,
  fetchSubscribedData,
} from "../../../../redux/checkout/actions";
import { getSmartBar } from "../../../../redux/home/actions";
import NotFoundComponent from "../../NotFound/NotFoundComponent";
import NewSubscriptionPriceCardComponent from "../NewSubscriptionPriceCard/NewSubscriptionPriceCardComponent";
import { useNavigate } from "react-router-dom";
import SimplePopup from "../../../modal/SimplePopup";
import SimplePopupCallback from "../../../modal/SimplePopupCallback";

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  dots: true,
  arrows: true,
  autoplaySpeed: 2000,
  infinite: false,
  centerMode: false,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const SubscriptionPriceSectionComponent = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  let isTesting = params.get("isTesting");

  const subscriptionPlan = useSelector(
    (state) => state.subscription.subscriptionPlan
  );
  const changeSubscriptionData = useSelector(
    (state) => state.checkout.changeSubscriptionPlan
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const drowngradeRes = useSelector(
      (state) => state.subscription.getDrowngradeDetailRes
    );

  const [apiList, setAPIList] = useState([]);
  // const [priceCardList, setPriceCardList] = useState([
  //     { isLoading: true }, { isLoading: true }, { isLoading: true },
  // ])
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState("");
  const [isConfirm, setIsConfirm] = useState(true);
  const { isLoggedIn, subscribedData } = useLogin();
  const [isFetching, setIsFetching] = useState(true);
  const [downgradedPopup, setDowngradedPopup] = useState(false);
  const [downgradedMsg, setDowngradedMsg] = useState("You subscription plan has been updated successfully.");
  const [isRightIcon, setIsRightIcon] = useState(true);

  useEffect(() => {
    if (props.fetchData) fetchSubscription();

    getSmartBarData();
  }, [dispatch, props.fetchData]);

  useEffect(() => {
    if (!_.isEmpty(subscriptionPlan)) {
      setIsFetching(false);
    }
  }, [subscriptionPlan]);

  const priceCardList = useMemo(() => {
    console.log("SUBSCRIPTION", subscriptionPlan);
    if (!_.isEmpty(subscriptionPlan)) {
      if (subscriptionPlan.status === "success") {
        let planList = subscriptionPlan.payload.data;
        if (!_.isEmpty(planList)) {
          let subscriptionList = [];
          planList = _.sortBy(planList, "weightage");
          let isCurrentlySubscribed = false;
          let subscribedPlanName = "";
          let subscribedBillingType = "";
          for (let [index, plan] of planList.entries()) {

            // if (isTesting === "true" && !plan?.title?.toLowerCase()?.includes("test")) {
            //   console.log("Skipping Testing Plan", plan.title);
            //   continue;
            // }


            // console.log("isTesting ", isTesting);
            // if((isTesting=== undefined || isTesting === null) && plan?.title?.toLowerCase()?.includes("test")){
            //   console.log("Skipping Testing Plan", plan.title);
            //   // alert("Skipping Testing Plan"+plan.title)
            //   continue;
            // }
            
            if (isCurrentlySubscribed && !subscribedPlanName) {
              isCurrentlySubscribed = false;
            }
            let planTitle = `Xsel Subscription ${plan.title} Plan`;
            let cardPrice = "Free";
            let cardPunchLine = "Zero cost forever";
            let btnName = "Sign up to access";
            let isPaid = false;
            let isUpgradePlan = false;
            let isDowngradePlan = false;

            // if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
            //   cardPrice = `$${plan.billed_yearly_price_per_mnth}/month`;
            // } else
            if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
              cardPrice = plan.billed_monthly_price_per_mnth;
              if (cardPrice.includes(".")) {
                cardPrice = `${cardPrice.split(".")[0]}<sup>${
                  cardPrice.split(".")[1]
                }</sup>`;
              }
              cardPrice = `$${cardPrice}`;
            }

            // if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
            //   cardPunchLine = "Billed anually";
            // } else if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
            //   cardPunchLine = "Billed monthly";
            // }

            if (
              _.toNumber(plan.billed_yearly_price_per_mnth) > 0 &&
              _.toNumber(plan.billed_monthly_price_per_mnth) > 0
            ) {
              cardPunchLine = "";
            }

            if (
              _.toNumber(plan.billed_monthly_price_per_mnth) > 0 ||
              _.toNumber(plan.billed_yearly_price_per_mnth) > 0
            ) {
              btnName = "Get started";
              isPaid = true;
            }

            // if (!isPaid && isLoggedIn) {
            //     btnName = "Change to this plan"
            // }

            if (
              _.toNumber(plan.billed_monthly_price_per_mnth) > 0 &&
              _.toNumber(plan.billed_yearly_price_per_mnth) > 0
            ) {
              planTitle = planTitle + " - Renews monthly or yearly";
            } else if (_.toNumber(plan.billed_monthly_price_per_mnth) > 0) {
              planTitle = planTitle + " - Renews monthly";
            } else if (_.toNumber(plan.billed_yearly_price_per_mnth) > 0) {
              planTitle = planTitle + " - Renews yearly";
            }

            if (isLoggedIn) {
              if (
                !_.isEmpty(subscribedData) &&
                subscribedData.subscription_active
              ) {
                if (subscribedData.ecom_sub_id === plan.id) {
                  isCurrentlySubscribed = true;
                  btnName = "You are currently on on this plan.";
                  subscribedPlanName = plan.title;
                  subscribedBillingType = subscribedData.billing_type;
                  // if (subscribedData.billing_type === "monthly") {
                  //   plan.billed_monthly_price_per_mnth = 0;
                  // } else if (subscribedData.billing_type === "annually") {
                  //   plan.billed_yearly_price_per_mnth = 0;
                  // }
                  for (let i of [...Array(index).keys()]) {
                    let lastSubData = subscriptionList[i];
                    console.log("last sub data", lastSubData);
                    // lastSubData.isCurrentlySubscribed = true;
                    if(lastSubData){
                    lastSubData.btnName = `Included in ${plan.title}`;
                    lastSubData.subscribedPlanName = plan.title;
                    lastSubData.isDowngradePlan = true;
                    }
                    // lastSubData.isUpgradePlan = true
                  }
                } else if (isCurrentlySubscribed) {
                  isUpgradePlan = true;
                  if (_.toNumber(plan.trial_period_in_days)) {
                    let entityName = subscriptionTrailType(
                      _.toNumber(plan.trial_period_in_days)
                    );
                    btnName = `Try it FREE for a ${entityName}`;
                  }
                }
              } else if (!isPaid && plan.weightage === 0) {
                btnName = "You are currently on this plan.";
                isCurrentlySubscribed = true;
              } else if (_.toNumber(plan.trial_period_in_days)) {
                let entityName = subscriptionTrailType(
                  _.toNumber(plan.trial_period_in_days)
                );
                btnName = `Try it FREE for a ${entityName}`;
                isCurrentlySubscribed = false;
              }
            }
            if(subscribedData?.upcoming_subscription)
            {
              if (subscribedData.upcoming_subscription?.ecom_subscription_id === plan.id)
              {
                // isCurrentlySubscribed = true;
              }
            }
            // alert(JSON.stringify(plan))

            subscriptionList.push({
              cardId: plan.id,
              cardTitle: plan.title,
              sessionCount: plan.free_session_per_month,
              // index === 2 ? "All" : plan.free_session_per_month,
              roleplayCount: plan.free_roleplays_count,
              rewardPoint: plan.reward_point,
              trialPeriodInDays: plan.trial_period_days,
              foundationCourses: plan.foundation_courses,
              videoAccess: plan.video_access,
              mobileAppAccess: _.toNumber(plan.mobile_app_access),
              exclusiveOffers: _.toNumber(plan.exclusive_offers),
              technicalSupport: _.toNumber(plan.technical_support),
              niitCoursesDiscount: _.toNumber(plan.niit_courses_discount),
              narCertificationDiscount: _.toNumber(
                plan.nar_certification_discount
              ),
              partnerCoursesDiscount: _.toNumber(plan.partner_courses_discount),
              coachingServiceDiscount: _.toNumber(
                plan.coaching_service_discount
              ),
              aiCourseDiscount: _.toNumber(plan.ai_course_discount),
              providerLogo: !_.isEmpty(plan.provider)
                ? plan.provider.provider_img
                  ? plan.provider.provider_img
                  : ""
                : "",
              isLoading: false,
              cardPriceInfo: {
                monthly: _.toNumber(plan.billed_monthly_price_per_mnth),
                yearly: _.toNumber(plan.billed_yearly_price_per_mnth),
                isAddToCart: true,
              },
              cardThumbnail: plan.subscription_img,
              cardPlanTitle: planTitle,
              cardLogo: plan.subscription_logo_path,
              isCurrentlySubscribed: isUpgradePlan
                ? false
                : isCurrentlySubscribed,
              isUpgradePlan,
              isDowngradePlan,
              isLoggedIn,
              isPaid,
              cardPrice,
              cardPunchLine,
              btnName,
              subscribedPlanName,
              subscribedBillingType,
            });
          }
          console.log("SUBSCRIPTIONLIST", subscriptionList);
          return subscriptionList;
        }
      }
    }
    if (isFetching) {
      return [{ isLoading: false }, { isLoading: false }, { isLoading: false }];
    }
    return [];
  }, [subscriptionPlan, subscribedData]);

  useEffect(() => {
    if (!_.isEmpty(changeSubscriptionData)) {
      console.log("CHANGE SUB PLAN DATA", changeSubscriptionData);
      setIsConfirm(false);
      if (changeSubscriptionData.status === "success") {
        setIsConfirm(false);
        callSubscribedApi();
        setIsRightIcon(true);
        setDowngradedMsg(changeSubscriptionData?.payload?.message || "Your subscription plan has been updated successfully.")
        setDowngradedPopup(true);
        props.setMainPageLoading(false);
      } else {
        setIsConfirm(false);
        setConfirmMsg(changeSubscriptionData?.error?.message);
        setConfirmModal(true);
        props.setMainPageLoading(false);
      }
      dispatch(changeSubscriptionPlanClear());
    }
  }, [changeSubscriptionData]);

  const callSubscribedApi = () =>{
    dispatch(
          fetchSubscribedData({
            method: "POST",
            URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.GET_SUBSCRIBED_DATA}`,
            payload: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            },
            isJSON: true,
          })
        );
  }

  const fetchSubscription = () => {
    let token = "";
    if (isLoggedIn || localStorage.getItem(SessionKeys.API_TOKEN_BROKER)) {
      token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    }
    dispatch(
      getSubscriptionPlan({
        URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_SUBSCRIPTION_PLAN}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        },
        isJSON: true,
        method: "post",
      })
    );
  };

  const getSmartBarData = () => {
    let token = localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
    dispatch(
      getSmartBar({
        module: "getSmartBar",
        postData: {
          token: token ? token : "",
        },
      })
    );
  };

  useEffect(()=>{
      console.log("Drowngrade Response", drowngradeRes);
      if(!_.isEmpty(drowngradeRes)){
        props.setMainPageLoading(false);
        if(drowngradeRes.status === "success"){
          setIsRightIcon(true);
          setDowngradedMsg(drowngradeRes?.payload?.message || "Your subscription plan has been updated successfully.");
          setDowngradedPopup(true);
          // setTimeout(() => {
          //   window.location.reload();
          // }, (2000));
        }else{
          setIsRightIcon(false);
          setDowngradedMsg(drowngradeRes?.error?.message || "Unable to process your request. Please try again later.");
          setDowngradedPopup(true);
        }
        dispatch(getDowngradeReqDetailsClear({}));

      }
    },[drowngradeRes])

  return (
    <>
      <section className="subscription-pricing pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-12">
              <div className="subscriptions-row" id="subscriptions-row">
                <span className="subscription-title">Xsel Subscriptions</span>
                <h2 className="">Simple, transparent pricing</h2>
                <span className="subscriptions-subhead">
                  Xsel is accessible to everyone. Different folks, different
                  needs.
                </span>
              </div>
            </div>
            <div className="col-md-4 col-12 text-md-end">
              <button type="button" className="view-all-btn" onClick={() => {navigate("/subscription-updated")}}>
                View Details
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                    stroke="#6941C6"
                    strokeWidth="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="col-md-4 col-12"></div>
          </div>
          <div className="col-md-12">
            <div className="prcieongnew">
              <div class="pricing-table">
                <div class="features-column">
                  <h3>Features</h3>
                  <ul>
                    <li>Foundational Courses</li>
                    <li>Video Library Access</li>
                    <li>Monthly Live Expert Webinar</li>
                    {false && <li>Mobile App</li>}
                    <li>Exclusive Offers on Select Purchases</li>
                    <li>Reward Points</li>
                    {/* <li>Access to Interactive Roleplays</li> */}
                    <li>Technical Support</li>
                    <li>Discounts on NIIT Courses</li>
                    <li>NAR Certification Course Discounts</li>
                    <li>Expert Partner Course Discounts</li>
                    <li>Coaching Services Discount</li>
                    <li>AI Course Discount</li>
                  </ul>
                </div>
                <div className="plan-wrpaer d-flex gap-3">
                  {/* <div class="plan">
                    <div class="plan-header">
                      <div className="planname">STARTER</div>
                      <div class="price">
                        FREE<sup>*</sup>
                      </div>
                      <div className="month">PER MONTH</div>
                    </div>

                    <div class="plan-details">
                      <ul>
                        <li>5</li>
                        <li>5 Videos</li>
                        <li>1</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>NA</li>
                        <li>1 point (per $1 spent)</li>
                        <li>NA</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>NA</li>
                        <li>NA</li>
                        <li>NA</li>
                        <li>NA</li>
                        <li>NA</li>
                      </ul>
                    </div>
                  </div> */}
                  {priceCardList.map((p, i) => {
                    return (
                      <NewSubscriptionPriceCardComponent
                        {...p}
                        setMainPageLoading={props.setMainPageLoading}
                        key={`price-card-${i + 1}`}
                      />
                    );
                  })}
                  {/* {!_.isEmpty(priceCardList) ? (
                    <Slider {...settings}>
                      {priceCardList.map((p, i) => {
                        return (
                          <div className="wrpper" key={i}>
                            <NewSubscriptionPriceCardComponent
                              {...p}
                              setMainPageLoading={props.setMainPageLoading}
                              key={`price-card-${i + 1}`}
                            />
                          </div>
                        );
                      })}
                    </Slider>
                  ) : (
                    <NotFoundComponent
                      width={400}
                      height={419}
                      showBtn={false}
                      showMsg={true}
                      msgLine={"No Subscription currently found for you."}
                    />
                  )} */}

                  {/* <div class="plan">
                    <div class="plan-header">
                      <div className="planname">PRO</div>
                      <div class="price">
                        $12<sup>99</sup>
                      </div>
                      <div className="month">PER MONTH</div>
                    </div>

                    <div class="plan-details">
                      <ul>
                        <li>10</li>
                        <li>15 Videos</li>
                        <li>2</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>2 point (per $1 spent)</li>
                        <li>2</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>5%</li>
                        <li>5%</li>
                        <li>5%</li>
                        <li>5%</li>
                        <li>5%</li>
                      </ul>
                    </div>
                  </div>

                  <div class="plan">
                    <div class="plan-header">
                      <div className="planname">PREMIUM</div>
                      <div class="price">
                        $99<sup>99</sup>
                      </div>
                      <div className="month">PER MONTH</div>
                    </div>

                    <div class="plan-details">
                      <ul>
                        <li>5</li>
                        <li>5 Videos</li>
                        <li>1</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>3 point (per $1 spent)</li>
                        <li>All</li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="rgba(25,229,128,1)"
                          >
                            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
                          </svg>
                        </li>
                        <li>10%</li>
                        <li>10%</li>
                        <li>10%</li>
                        <li>10%</li>
                        <li>10%</li>
                      </ul>
                    </div>
                  </div> */}
                </div>
              </div>
              {authBroker.payload?.user?.is_corporate && (
                <div class="note">
                  *Starter subscription worth $9.99 monthly complimentary for
                  C21 agents for a limited time.
                </div>
              )}
            </div>
          </div>
          {/* <div className="row coursecard-row">
            {!_.isEmpty(priceCardList) ? (
              <Slider {...settings}>
                {priceCardList.map((p, i) => {
                  return (
                    <div className="wrpper" key={i}>
                      <SubscriptionPriceCardComponent
                        {...p}
                        setMainPageLoading={props.setMainPageLoading}
                        key={`price-card-${i + 1}`}
                      />
                    </div>
                  );
                })}
              </Slider>
            ) : (
              <NotFoundComponent
                width={400}
                height={419}
                showBtn={false}
                showMsg={true}
                msgLine={"No Subscription currently found for you."}
              />
            )}
          </div> */}
          <ConfirmModal
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={confirmMsg}
            isConfirm={isConfirm}
            confirmId=""
            confirmAction={() => {
              setConfirmModal(false);
            }}
          />
          <SimplePopupCallback
                  confirmModal={downgradedPopup}
                  setConfirmModal={setDowngradedPopup}
                  showModalMsg={downgradedMsg}
                  isRightIcon={isRightIcon}
                  clickOk={() => {
                    window.location.reload();
                    setDowngradedPopup(false);
                  }}
                />
        </div>
      </section>
    </>
  );
};

export default SubscriptionPriceSectionComponent;
